import { GET_BANNERS } from '../constants/bannersTypes';

export function getBanners() {
  return { type: GET_BANNERS };
}



// WEBPACK FOOTER //
// ./app/actions/bannersActions.js